<template>
    <div id="app">
        <!-- <router-view/> -->
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"/>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
import './App.scss';
import {mapMutations, mapActions, mapState} from 'vuex';
import Const from '@/pages/dache-activity/constant/Constant';

export default {
    name: 'app',
    created() {
        this.setLocalParams();
        this.localParams.stbar_height && this.setSafeHeight(Number(this.localParams.stbar_height));
    },
    computed: {
        ...mapState([
            'localParams'
        ])
    },
    methods: {
        ...mapMutations([
            'setSafeHeight'
        ]),
        ...mapActions([
            'setLocalParams'
        ])
    }
};
</script>
